var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardCreateContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 128,
    viewBox: "0 0 240 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.0916 0L55.6436 20.3786H57.7527V36.9967H47.1235L41 48.9403L116.875 87.8415L141.967 38.9012L66.0916 0Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.212 13.2566H63.8857V71.6175H180.212V13.2566Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.067 34.2271H80.207V34.4249H166.067V34.2271Z",
    fill: "#17A680"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.166 39.1729H80.3059V39.3707H166.166V39.1729Z",
    fill: "#17A680"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.166 49.0645H80.3059V49.2623H166.166V49.0645Z",
    fill: "#17A680"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.166 53.4167H80.3059V53.6146H166.166V53.4167Z",
    fill: "#17A680"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.166 44.1187H80.3059V44.3165H166.166V44.1187Z",
    fill: "#17A680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.109 128C173.431 128 189.906 126.494 189.906 124.637C189.906 122.779 173.431 121.274 153.109 121.274C132.786 121.274 116.312 122.779 116.312 124.637C116.312 126.494 132.786 128 153.109 128Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6878 53.5601L82.4148 53.2736L95.195 41.0925L106.461 49.1961L115.571 39.0955L119.566 42.4911L130.433 35.9709L142.504 44.0839L161.448 33.3081L161.644 33.6519L142.486 44.549L130.421 36.4396L119.526 42.9764L115.608 39.6457L106.517 49.7241L95.2303 41.6054L82.6878 53.5601Z",
    fill: "#17A680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.492 117.878C120.422 121.316 123.606 123.444 123.606 123.444C123.606 123.444 125.284 120 124.354 116.563C123.424 113.126 120.239 110.997 120.239 110.997C120.239 110.997 118.562 114.441 119.492 117.878Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.858 117.14C123.41 119.624 123.721 123.442 123.721 123.442C123.721 123.442 119.896 123.233 117.345 120.749C114.793 118.265 114.482 114.447 114.482 114.447C114.482 114.447 118.307 114.656 120.858 117.14Z",
    fill: "#17A680"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M192.378 17.2133C196.039 17.2133 199.006 14.2461 199.006 10.5859C199.006 6.9257 196.039 3.9585 192.378 3.9585C188.718 3.9585 185.751 6.9257 185.751 10.5859C185.751 14.2461 188.718 17.2133 192.378 17.2133Z",
    fill: "#17A680"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M180.113 18.4002C182.681 18.4002 184.762 16.3188 184.762 13.7511C184.762 11.1835 182.681 9.10205 180.113 9.10205C177.545 9.10205 175.464 11.1835 175.464 13.7511C175.464 16.3188 177.545 18.4002 180.113 18.4002Z",
    fill: "#17A680"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M174.376 101.49C175.742 101.49 176.849 100.383 176.849 99.0174C176.849 97.6516 175.742 96.5444 174.376 96.5444C173.01 96.5444 171.903 97.6516 171.903 99.0174C171.903 100.383 173.01 101.49 174.376 101.49Z",
    fill: "#17A680"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M132.237 113.756C133.275 113.756 134.117 112.914 134.117 111.876C134.117 110.839 133.275 109.997 132.237 109.997C131.199 109.997 130.358 110.839 130.358 111.876C130.358 112.914 131.199 113.756 132.237 113.756Z",
    fill: "#17A680"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M125.906 89.4224C127.272 89.4224 128.379 88.3152 128.379 86.9495C128.379 85.5837 127.272 84.4766 125.906 84.4766C124.541 84.4766 123.434 85.5837 123.434 86.9495C123.434 88.3152 124.541 89.4224 125.906 89.4224Z",
    fill: "#17A680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.319 36.8978C162.739 36.8978 163.89 35.7464 163.89 34.326C163.89 32.9056 162.739 31.7542 161.319 31.7542C159.898 31.7542 158.747 32.9056 158.747 34.326C158.747 35.7464 159.898 36.8978 161.319 36.8978Z",
    fill: "#17A680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.608 80.9089L142.428 81.1512C142.428 81.1512 141.459 85.5116 142.428 91.3256C143.397 97.1395 144.608 102.953 144.608 102.953C144.608 102.953 145.577 121.849 146.062 122.091C146.546 122.333 150.907 123.787 151.149 122.333C151.391 120.88 151.391 87.6919 151.391 87.6919L154.783 103.68C154.783 103.68 155.267 123.787 156.236 123.787C157.205 123.787 160.354 123.544 160.354 121.849C160.354 120.153 161.081 97.8662 161.081 97.8662C161.081 97.8662 160.839 81.3934 159.87 80.9089C158.901 80.4244 144.608 80.9089 144.608 80.9089Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.546 121.364C146.546 121.364 144.366 121.122 143.881 121.364C143.397 121.606 142.67 123.302 143.881 124.271C145.093 125.24 148.242 126.693 149.211 126.693C149.883 126.664 150.542 126.499 151.149 126.209L150.664 122.091L146.546 121.364Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.236 122.575L156.478 125.967C156.478 125.967 159.628 126.451 159.87 125.967C160.112 125.482 162.534 124.271 162.777 124.029C163.019 123.787 163.261 121.122 161.808 120.88C160.354 120.638 159.87 121.364 159.87 121.364L156.236 122.575Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.887 60.5601C135.887 60.5601 130.073 66.1318 130.8 69.0387C131.527 71.9457 137.341 80.4243 137.341 80.4243C137.341 80.4243 142.913 83.3313 143.639 80.4243C144.366 77.5174 139.763 78.2441 139.763 78.2441L136.13 69.5232L140.248 63.7093L135.887 60.5601Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.865 52.0836C161.865 52.0836 167.162 48.6777 167.039 46.3379C166.917 43.998 163.724 36.6203 163.724 36.6203C163.724 36.6203 161.226 31.4273 160.233 33.5496C159.24 35.6719 161.538 37.931 161.538 37.931L163.021 45.1682L158.99 49.0138L161.865 52.0836Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.726 47.2365C151.135 47.2365 153.087 45.2843 153.087 42.8761C153.087 40.4679 151.135 38.5156 148.726 38.5156C146.318 38.5156 144.366 40.4679 144.366 42.8761C144.366 45.2843 146.318 47.2365 148.726 47.2365Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.546 45.5408L147.273 50.1435L152.602 49.1745C152.602 49.1745 152.36 44.5718 152.36 44.0873C152.36 43.6028 146.546 45.5408 146.546 45.5408Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.304 50.1436C146.304 50.1436 152.36 48.6901 153.087 49.1746C153.814 49.6591 157.447 50.1436 157.447 50.1436L161.565 56.442L160.354 64.4361C160.354 64.4361 160.112 77.2753 160.596 79.4555C161.081 81.6357 163.746 81.8779 158.174 82.3624C152.602 82.8469 151.633 82.1202 147.757 83.0892C143.881 84.0582 140.732 82.6047 141.701 81.6357C142.67 80.6667 144.366 65.1629 142.428 63.7094C140.49 62.2559 139.763 54.7462 139.763 54.7462C139.763 54.7462 146.304 51.3548 146.304 50.1436Z",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.72 50.8702L157.447 50.1434L158.901 48.6899C158.901 48.6899 163.624 50.749 163.382 51.4758C163.14 52.2025 161.565 56.4419 161.565 56.4419L159.385 57.1686L156.72 50.8702Z",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.67 55.2306L139.763 54.7461C139.763 54.7461 137.583 57.1686 136.856 58.1376C136.13 59.1065 134.676 61.529 134.676 61.529L139.763 65.1627L143.639 61.0445L142.67 55.2306Z",
    fill: "#D0CDE1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.248 37.5932L150.203 37.2439C149.907 37.2422 149.612 37.2886 149.331 37.3811C149.302 37.1704 149.32 36.956 149.384 36.7534C149.098 36.8269 148.826 36.9455 148.577 37.1045L148.401 36.467L145.979 37.6605C145.11 38.089 144.193 38.5598 143.696 39.3918C143.142 40.3194 143.239 41.5115 143.617 42.5234C143.996 43.5353 144.625 44.4308 145.13 45.3862C145.321 45.7971 145.551 46.1888 145.817 46.5561C146.731 47.6956 148.51 47.9258 149.799 47.2381C150.29 47.0018 150.681 46.5995 150.903 46.1025C150.997 45.7942 151.07 45.4801 151.123 45.1621C151.283 44.511 151.468 43.1668 151.997 42.7548C152.229 42.5736 152.691 43.1745 152.884 42.9513C153.379 42.3776 153.275 41.4929 152.967 40.8001C152.672 40.1043 152.327 39.4307 151.934 38.7847C151.768 38.5249 150.243 37.5513 150.248 37.5932Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1701 22.7527H43.5088V35.414H56.1701V22.7527Z",
    fill: "#3F3D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158.006,
    height: 128,
    fill: "white",
    transform: "translate(41)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCreateContract);
export default __webpack_public_path__ + "static/media/card-create-contract.e5a9be2b8a5edafbb2cb3b22d02811d8.svg";
export { ForwardRef as ReactComponent };